import axios from 'axios'

const state = {
  lat: null,
  lon: null,
  zoom: null,
  boundsLeft: null,
  boundsRight: null,
  boundsTop: null,
  boundsBottom: null,
  markers: [],
  selectedMarkerId: null,
  onLoading: false,
  centerPin: { lat: null, lng: null },
  resultListOpen: true
}

const getters = {
  mapLat: (state) => {
    return state.lat
  },
  mapLon: (state) => {
    return state.lon
  },
  mapZoom: (state) => {
    return state.zoom
  },
  mapMarkers: (state) => {
    return state.markers
  },
  mapBoundsRight: (state) => {
    return state.boundsRight
  },
  mapBoundsLeft: (state) => {
    return state.boundsLeft
  },
  mapBoundsTop: (state) => {
    return state.boundsTop
  },
  mapBoundsBottom: (state) => {
    return state.boundsBottom
  },
  mapSelectedMarkerId: (state) => {
    return state.selectedMarkerId
  },
  mapOnLoading: (state) => {
    return state.onLoading
  },
  mapCenterPin: (state) => {
    return state.centerPin
  },
  mapResultListOpen: (state) => {
    return state.resultListOpen
  },
}

const mutations = {
  setLat(state, payload) {
    state.lat = payload
  },
  setLon(state, payload) {
    state.lon = payload
  },
  setZoom(state, payload) {
    state.zoom = payload
  },
  setMarkers(state, payload) {
    state.markers = payload
  },
  setBoundsRight(state, payload) {
    state.boundsRight = payload
  },
  setBoundsLeft(state, payload) {
    state.boundsLeft = payload
  },
  setBoundsTop(state, payload) {
    state.boundsTop = payload
  },
  setBoundsBottom(state, payload) {
    state.boundsBottom = payload
  },
  setSelectedMarkerId(state, payload) {
    state.selectedMarkerId = payload
  },
  setOnLoading(state, payload) {
    state.onLoading = payload
  },
  setCenterPin(state, payload) {
    state.centerPin = payload
  },
  setResultListOpen(state, payload) {
    state.resultListOpen = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}


